// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7892) return "static/chunks/7892-6531a0252e12364c.js";
	if (chunkId === 6398) return "static/chunks/6398-5fe7c2b8a5b206ad.js";
	if (chunkId === 7555) return "static/chunks/7555-14ffe9279b3cb5d1.js";
	if (chunkId === 2505) return "static/chunks/2505-32775a343316b5ce.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3644":"82148e4926e95b28","4622":"48591f19f0083937","6793":"f57464ca23fa9330","8248":"e03dd95ef9433345"}[chunkId] + ".js";
};